import api from './api';
import type { Address } from '@/types';

// The owner-search endpoint only returns what's needed to prefill owner details + address -
// membershipNumber/membershipLevel/prospectId are contract-specific and never included.
export interface OwnerSearchResult {
  _id: number;
  title?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address: Address;
}

// Description: Search existing owners by membership number, for the "Owner ID" autocomplete
// Endpoint: GET /api/clc/owners/search
// Request: { membershipNumber: string }
// Response: { owners: OwnerSearchResult[] }
export const searchOwners = async (membershipNumber: string): Promise<OwnerSearchResult[]> => {
  try {
    const response = await api.get('/api/clc/owners/search', {
      params: { membershipNumber },
    });
    return Array.isArray(response.data?.owners) ? response.data.owners : [];
  } catch (error) {
    console.error('Error searching owners:', error);
    return [];
  }
};
